import { createEndpoints } from '../../_helpers/utile/endpoint.helper';

export const TERMS_CONDITIONS_ENDPOINTS = {
  V1: createEndpoints('v1', {
    TERMS_CONDITIONS_TEMPLATES: '/admin/terms-and-conditions-templates/',
    TERMS_CONDITION_TEMPLATE_DETAIL: (id: number) => `/admin/terms-and-conditions-templates/${id}/`,
  }),
} as const;
